import { moment, objectToList } from "@/utils"
import AppService from "./app-service"

const path = "receivables"

export default class ReceivableService extends AppService {

  constructor() {
    super({ path })
  }

  static get TYPES() {
    return {
      normal: { 
        id: "normal",
        icon: "file alternate outline icon", 
        label: '<i class="file alternate outline icon"></i> Normal',
        description: "Normal" 
      },
      credit: { 
        id: "credit",
        icon: "donate teal icon", 
        label: '<i class="donate teal icon"></i> Crédito',
        description: "Crédito",
      },
    }
  }

  static get STATUS() {
    return {
      paid: { 
        id: "paid",
        icon: "check circle green icon",
        label: '<i class="check circle green icon"></i> Baixado',
        description: "Baixado",              
      },
      expired: { 
        id: "expired",
        icon: "exclamation circle red icon", 
        label: '<i class="exclamation circle red icon"></i> Vencido',
        description: "Vencido", 
      },
      half_paid: { 
        id: "half_paid",
        icon: "check circle outline blue icon", 
        label: '<i class="check circle outline blue icon"></i> Baixado parcialmente',
        description: "Baixado parcialmente",
      },
      open: {
        id: "open",
        icon: "clock outline orange icon",
        label: '<i class="clock outline orange icon"></i> Em aberto',
        description: "Em aberto",
      },
    }
  }

  static getStatusList() {    
    return objectToList(ReceivableService.STATUS)
  }

  static getTypeList() {    
    return objectToList(ReceivableService.TYPES)
  }

  static getStatus(receivable) {
    
    let status = ""
    const { realDueDate, value, balance } = receivable
    const dueDate = moment(realDueDate).format("YYYYMMDD")
    const today = moment().format("YYYYMMDD")

    if (balance == 0) {

      status = "paid"

    } else if (dueDate < today) {

      status = "expired"

    } else if (balance > 0 && balance < value) {

      status = "half_paid"

    } else {

      status = "open"
    }

    return ReceivableService.STATUS[status]
  }

  filter(data) {
    return this.http.post(`${path}/filter`, data).then((receivables) => {
      receivables.forEach(ReceivableService.setReceivableData)
      return receivables
    })
  }

  onFindAll(receivables) {
    receivables.forEach(ReceivableService.setReceivableData)
  }

  static setReceivableData(receivable) {
    receivable.isExpired = ReceivableService.isExpired(receivable)
    receivable.statusData = ReceivableService.getStatus(receivable)
    receivable.typeData = ReceivableService.TYPES[receivable.type]
  }

  static isExpired(receivable)  {

    if (receivable.balance == 0)
      return false
    
    const today = moment().format("YYYYMMDD")
    const realDueDate = moment(receivable.realDueDate).format("YYYYMMDD")

    return (realDueDate < today)
  }

  settle(receivableId, data) {

    if (!data.date)
      data.date = moment(data.date).format("YYYY-MM-DD")

    return this.http.post(`${path}/${receivableId}/settles`, data)
  }

  deleteSettle(receivableId, settleId) {
    return this.http.delete(`${path}/${receivableId}/settles/${settleId}`)
  }

  getCredits(receivableId) {
    return this.http.get(`${path}/${receivableId}/credits`)
  }

  getCompensation(compensationId) {
    return this.http.get(`receivable-compensations/${compensationId}`)
  }
}